import { useRecoilTransaction_UNSTABLE } from "recoil"

import { designLocalState } from "~/containers/Proposal/state/designs/design-state"

import type { TransactionOperation } from "."
import { edgeIndex, edgeSelectionState } from "../edges"
import { nodeIndex } from "../nodes"
import { nodeSelectionState_INTERNAL } from "../nodeSelection"
import { panelIndex, panelSelectionState } from "../panels"

export const selectAll: TransactionOperation = ({ set, get }) => {
  const { phase } = get(designLocalState)
  switch (phase) {
    case `Outline`:
      set(nodeSelectionState_INTERNAL, new Set(get(nodeIndex)))
      set(edgeSelectionState, new Set(get(edgeIndex)))
      break
    case `Panel Placement`:
      set(panelSelectionState, new Set(get(panelIndex)))
      break
  }
}
export const useSelectAll = (): VoidFunction =>
  useRecoilTransaction_UNSTABLE((transactors) => () => selectAll(transactors))
